// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const campfire = defineModel({
  id: "campfire",
  batchId: "future",
  name: "Campfire",
  tags: ["scenery","campfire","low-poly","age-of-mcp","future"],
  summary: "A campfire — light, warmth and a gathering point in the wild.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.3,
  parts: () => [
      { geometry: new THREE.IcosahedronGeometry(0.055, 0), color: "#615b51", position: [0.2, 0.04, 0], scale: [1, 0.8, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.055, 0), color: "#7d776b", position: [0.141421, 0.04, 0.141421], scale: [1, 0.8, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.055, 0), color: "#615b51", position: [0, 0.04, 0.2], scale: [1, 0.8, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.055, 0), color: "#7d776b", position: [-0.141421, 0.04, 0.141421], scale: [1, 0.8, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.055, 0), color: "#615b51", position: [-0.2, 0.04, 0], scale: [1, 0.8, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.055, 0), color: "#7d776b", position: [-0.141421, 0.04, -0.141421], scale: [1, 0.8, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.055, 0), color: "#615b51", position: [0, 0.04, -0.2], scale: [1, 0.8, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.055, 0), color: "#7d776b", position: [0.141421, 0.04, -0.141421], scale: [1, 0.8, 1] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.34, 6), color: "#6f4a26", position: [0, 0.06, 0], rotation: [0, 0.5, 1.570796] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.34, 6), color: "#6f4a26", position: [0, 0.06, 0], rotation: [0, -0.6, 1.570796] },
      { geometry: new THREE.CircleGeometry(0.025, 6), color: "#c2a070", position: [0.16, 0.06, 0.09], rotation: [0, 1.07, 0] },
      { geometry: new THREE.IcosahedronGeometry(0.08, 0), color: "#c43a20", position: [0, 0.07, 0], scale: [1, 0.5, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.04, 0), color: "#ff6a2a", position: [0.02, 0.09, 0] },
      { geometry: new THREE.ConeGeometry(0.08, 0.26, 7), color: "#ff9a32", position: [0, 0.22, 0] },
      { geometry: new THREE.ConeGeometry(0.045, 0.32, 6), color: "#ffd24a", position: [0.015, 0.28, 0.01] },
      { geometry: new THREE.CylinderGeometry(0.05, 0.05, 0.4, 7), color: "#7a512c", position: [0.36, 0.05, 0.1], rotation: [1.570796, 0.3, 0] },
      { geometry: new THREE.CircleGeometry(0.05, 7), color: "#c2a070", position: [0.551067, 0.05, 0.040896], rotation: [0, 1.870796, 0] },
      { geometry: new THREE.CylinderGeometry(0.05, 0.05, 0.4, 7), color: "#7a512c", position: [-0.34, 0.05, -0.12], rotation: [1.570796, -0.4, 0] },
      { geometry: new THREE.CircleGeometry(0.05, 7), color: "#c2a070", position: [-0.155788, 0.05, -0.042116], rotation: [0, 1.170796, 0] },
    ],
  animations: [],
});
